import React, {FC} from 'react';
import styles from './Archiving.module.scss';
import Stack from '@mui/material/Stack';
import DSC from "../../../assets/images/DSC-eticw_2.jpg";
import {Helmet} from "react-helmet";


interface ArchivingProps {
}

const Archiving: FC<ArchivingProps> = () => (
    <><Helmet>
        <meta charSet="utf-8"/>
        <title>Archiving</title>
    </Helmet>
        <div className={styles.Archiving}>

            <div className="standard-margin">
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    spacing={2}
                >
                    <div>
                        <h2>Archiving with Tic </h2>
                        <hr></hr>

                        <p>Technical Information Center (TIC) was established in 1972 to preserve and provide ready
                            access
                            to Park Service wide infrastructure information.
                            TIC encourages National Park Service (<abbr>NPS</abbr>) offices to send their drawings along
                            with final/completed reports and documents to TIC for scanning, indexing, inclusion
                            into <abbr>e</abbr>TIC2
                            (electronic Technical Information Center), and electronic archiving
                            with the National Archives (NARA).<br></br><br></br>TIC will scan and return these documents
                            upon request. This
                            process ensures that the resource management material will last beyond any possible damage
                            or loss in a park or
                            central office. Drawings are scanned without charge when the collections are entered into
                            the regular scanning queue.
                            Only high priority projects that require additional resources and staff may have fees.
                            <br></br><br></br>TIC staff are available to inventory and pack drawings for shipment from
                            park offices to the Denver Service Center (<abbr>DSC</abbr>) for
                            cataloging and scanning. The park will be required to cover normal travel costs.</p>
                    </div>
                    <span>
                        <a href={require('../../../assets/images/DSC-eticw_2.jpg')} target="_blank">
                            <img src={DSC} alt="team" className={styles.boxes}/></a>
                    </span>
                </Stack>


                <div className="textContent">

                    <div><p><b>Reasons to archive:</b></p>
                        <ul className="closeTop">
                            <li>TIC is a central repository that provides electronic access to drawings and reports
                                via <abbr>e</abbr>TIC2 and paper copies
                                when requested, as mandated by <a href="https://www.nps.gov/policy/DOrders/DO_11D.pdf"
                                                                  target="_blank" id="anch_36">Director’s Order #11D</a>.
                            </li>
                            <li>Share and collaborate within <abbr>NPS</abbr> important infrastructure information.</li>
                            <li>Make important technical records available.</li>
                            <li>Duplication of drawings prevents information loss when one copy is destroyed or lost.
                            </li>
                            <li>Paper drawings stored off-site take up less space in park.</li>
                            <li>Faster response to the public for Freedom of Information Act (FOIA) or other public
                                inquires.
                            </li>
                            <li>Supports Call To Action 17, our vision is to offer our audience comprehensive
                                information about the National Park Service’s assets.
                            </li>
                        </ul>
                        <p><b>Additional Services/Contracts that TIC Provides:</b></p>
                        <ul className="closeTop">
                            <li>Scanning Equipment:
                                <ul>
                                    <li>WideTek color/monochrome drawing scanner (48 inches wide; up to 1200 <abbr
                                        title="dots per inch">dpi</abbr>)
                                    </li>
                                    <li>Océ TC4 color scanner (36 inches wide; up to 600 <abbr>dpi</abbr>)</li>
                                    <li>Kodak i4850 document scanner, 300 <abbr>dpi</abbr>, scans up to 11 x 17 pages,
                                        color/black
                                        and white
                                    </li>
                                </ul>
                            </li>
                            <li>Existing Government Publishing Office (<abbr>GPO</abbr>) contract for large scale
                                scanning.
                            </li>
                            <li>Warehouse space to receive large shipments.</li>
                            <li>Setup with NARA’s Electronic Records Archive (<abbr>ERA</abbr>), our system can export
                                data
                                to <abbr>ERA</abbr>.
                            </li>
                            <li>Staff works closely with the Federal Records Center.</li>
                            <li>Existing courier contract to deliver boxes from Federal Records Center (<abbr>FRC</abbr>)/National
                                Archives (NARA)-Broomfield,
                                Contracting Officer (<abbr>CO</abbr>) to TIC on a weekly basis.
                            </li>
                            <li>All scans have a rendered <abbr>PDF-A</abbr> revision (archive-able Portable Document
                                Format)
                            </li>
                            <li><abbr>e</abbr>TIC Public Website – Get your public docs and drawings out to the public.
                                <ul>
                                    <li><a href="https://pubs.etic.nps.gov/" target="_blank"
                                           id="anch_37">etic.pubs.nps.gov</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <br></br><br></br><br></br>
                    </div>
                </div>
            </div>
        </div>
    </>

);

export default Archiving;
